import { render } from "./loginConfig.vue?vue&type=template&id=6149cd20&scoped=true"
import script from "./loginConfig.vue?vue&type=script&lang=js"
export * from "./loginConfig.vue?vue&type=script&lang=js"

import "./loginConfig.vue?vue&type=style&index=0&id=6149cd20&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mamidou/mamidou/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6149cd20"]])

export default __exports__